// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"385":"chunk_featuredata","687":"chunk_metadataflyout","874":"chunk_maplegend"}[chunkId] || chunkId) + "/oskari.min.js";
};